import { render, staticRenderFns } from "./RolesHolder.vue?vue&type=template&id=6a4833ef"
import script from "./RolesHolder.vue?vue&type=script&lang=js"
export * from "./RolesHolder.vue?vue&type=script&lang=js"
import style0 from "./RolesHolder.vue?vue&type=style&index=0&id=6a4833ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports